import { render, staticRenderFns } from "./LiansuoGoodsList.vue?vue&type=template&id=92babf92&scoped=true"
import script from "./LiansuoGoodsList.vue?vue&type=script&lang=js"
export * from "./LiansuoGoodsList.vue?vue&type=script&lang=js"
import style0 from "./LiansuoGoodsList.vue?vue&type=style&index=0&id=92babf92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92babf92",
  null
  
)

export default component.exports